// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageCheckoutSuccess_wrapper__10OoM","message":"PageCheckoutSuccess_message__1QyY9"};